export const BLOCKHASH_STREAM_COMMITMENT = 'confirmed';

export const BLOCKHASH_LOCAL_CACHE_TTL_MS = 1_000;

export const BLOCKHASH_RESOLVER_MODES = ['off', 'observe', 'stream'] as const;
export type BlockhashResolverMode = (typeof BLOCKHASH_RESOLVER_MODES)[number];

export function isBlockhashResolverMode(value: unknown): value is BlockhashResolverMode {
  return BLOCKHASH_RESOLVER_MODES.some((mode) => mode === value);
}

export const DEFAULT_BLOCKHASH_RESOLVER_MODE: BlockhashResolverMode = parseBlockhashResolverMode(
  typeof process !== 'undefined' && process.env !== undefined
    ? (process.env.NEXT_PUBLIC_MORFI_BLOCKHASH_RESOLVER_MODE ??
        process.env.EXPO_PUBLIC_MORFI_BLOCKHASH_RESOLVER_MODE ??
        process.env.MORFI_BLOCKHASH_RESOLVER_MODE ??
        'stream')
    : 'stream',
  'stream',
);

export function parseBlockhashResolverMode(
  raw: string | undefined,
  fallback?: BlockhashResolverMode,
): BlockhashResolverMode {
  const value = (raw ?? '').trim();
  if (isBlockhashResolverMode(value)) return value;
  if (fallback !== undefined) return fallback;
  throw new Error('BLOCKHASH_RESOLVER_MODE must be one of: off, observe, stream');
}
